import { render, staticRenderFns } from "./folder-system.vue?vue&type=template&id=8639874a"
import script from "./folder-system.vue?vue&type=script&lang=ts"
export * from "./folder-system.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports